import DOMPurify from 'dompurify';

// Client-side defense-in-depth for any HTML rendered via dangerouslySetInnerHTML
// (backend also sanitizes on save with bleach, but this protects against any
// content saved before that guard existed, or fields not covered by it).
export const sanitizeHtml = (html) => {
  if (!html) return html;
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'img', 'blockquote'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt'],
  });
};
